import { useEffect } from "react";
import Navbar from "../Navbar";
import DisplayGame from "../Play/GameUI/GameIndex";

/**
 * Renders the "/duels" page
 * @returns html containing a duels game
 */
const Duels = () => {
  useEffect(() => {
    document.title = "Duels - FPS Aim Trainer";
  }, []);

  return (
    <div className="h-screen flex flex-col">
      <Navbar />
      <div className="w-screen flex-1">
        <DisplayGame ironsights={false} duels />
      </div>
    </div>
  );
};

export default Duels;
